<div class="col-md-10">
<!--div *ngIf="failure" class="text-danger" i18n="@@msgFailure"><b>"The email id is already registered. Please use a different email id or click on 'Reset Your Password' link to reset your password."</b></div-->       
<h3 i18n="@@RegistrationIndividualsHeader">Start Reference Checks - Registration for Individuals / Vendors</h3>
<form *ngIf="!success" novalidate (ngSubmit)="register(registerForm.value, registerForm.valid)" #registerForm="ngForm" autocomplete="off" >
      <div *ngIf="failure" class="alert alert-danger" i18n="@@valAlreadyRegisteredInd">The email id is already registered as individual/vendor. To reset your password click on <a [routerLink]="['/ind-forgot-password']" class="btn btn-link">Reset Your Password</a> <br/>  Or <a (click)='refresh()' class="btn btn-link">Click here to register with a different email.</a></div> 
      <div><a [routerLink]="['/org-register']" class="btn btn-link" i18n="@@lnkNotAnIndRegisterOrg">Not an Individual / Vendor ? Click here to Register as an Organization.</a></div>
      <div class="form-group">
            <label for="firstname" i18n="@@lblFirstName"> First Name : </label>
            <input type="text" class="form-control" id="firstname" name="firstname" autocomplete="off" [(ngModel)]="model.firstname" 
            #firstname="ngModel" required autofocus>
            <div [hidden]="firstname.valid || firstname.pristine" class="alert alert-danger" i18n="@@valFirstNameReqd">
                  First Name is required.
            </div>
      </div>          
      <div class="form-group">
            <label for="lastname" i18n="@@lblLastName"> Last Name : </label>
            <input type="text" class="form-control" id="lastname" name="lastname" autocomplete="off" [(ngModel)]="model.lastname" 
            #lastname="ngModel" required>
            <div [hidden]="lastname.valid || lastname.pristine" class="alert alert-danger" i18n="@@valLastNameReqd">
                  Last Name is required.
            </div>
      </div>                      
      <div class="form-group">
            <label for="email" i18n="@@lblEmail"> Email : </label>
            <input type="email" class="form-control" id="email" name="email" autocomplete="off" [(ngModel)]="model.email" 
            #email="ngModel" required pattern="[A-Za-z0-9._%+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,4}$">
            <div [hidden]="email.valid || email.pristine" class="alert alert-danger" i18n="@@valEnterValidEmail">
                  Please enter a valid email id.
            </div>
      </div>
      <div class="form-group">
            <label for="password" i18n="@@lblPwdMin">Password :  (min 8 chars)</label>
            <input type="password" class="form-control" id="password" name="password" autocomplete="off" [(ngModel)]="model.password" 
            #password="ngModel" required validateEqual="password2" reverse="true" pattern=".{8,}">  
            <div [hidden]="password.valid || password.pristine" class="alert alert-danger" i18n="@@valMin8PwdReqd">
                  Password is required (minimum length 8 characters).
            </div>
      </div>
      <div class="form-group">
            <label for="password2" i18n="@@lblReenterPwd">Re-enter Password : </label>
            <input type="password" class="form-control" id="password2" name="password2" autocomplete="off" [(ngModel)]="model.password2" 
            #password2="ngModel" required validateEqual="password"  reverse="false" >  
            <div [hidden]="(password2.valid && (password.value === password2.value)) || password2.pristine" class="alert alert-danger" i18n="@@valReenterPwd">
                  Re enter Password does not match the Password entered above.
            </div>
      </div>
      <re-captcha
            [(ngModel)]="formModel.captcha"
            name="captcha"
            required
            siteKey="6LfQfCkUAAAAAJgZfY8xY3JdG71PSrxNazVm-2Ol"
            #captchaControl="ngModel"
      ></re-captcha>
      <div class="form-group">               
            <!--<button type="submit" class="btn btn-primary" [disabled]="!registerForm.valid || loading || failure" i18n="@@btnSubmit">Submit</button>-->
            <button type="submit" class="btn btn-primary" [disabled]="!registerForm.valid || loading || failure " ><span i18n="@@btnSubmit"> Submit </span> <i *ngIf="loading" class="fa fa-spinner fa-pulse"></i></button>
            <a *ngIf="!loading" [routerLink]="['/ind/ind-login']" class="btn btn-link" i18n="@@btnCancel">Cancel</a>            
      </div>
</form>
<div *ngIf="success" i18n="@@msgCheckEmailVerifLink">Please check your email for the verification link to complete the registration. If you did not receive the email, check if the email was saved in your email spam. Thanks.</div>
<div *ngIf="success"><a [routerLink]="['/ind/ind-login']" class="btn btn-link" i18n="@@msgGoToLogin">Go to Sign In page</a></div>
<div *ngIf="alreadyregistered"><a [routerLink]="['/ind/ind-forgot-password']" class="btn btn-link" i18n="@@msgGoToResetYourPassword">Go to Reset Your Password</a></div>
</div>